import React from "react";
import PageBanner from "../PageBanner/PageBanner";
import {
  COURSES_PAGE_BANNER,
  COURSES_PAGE_SHOW_COURSES_FILTER,
} from "../../constants/text_constants";
import BANNER_IMG from "../../assets/GirlWithLaptop.png";
import BACKGROUND_IMAGE from "../../assets/BgOverlayImage.jpeg";
import CoursesList from "./CoursesList";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import userLogout from "../../utils/userLogout";
import useAutoLogout from "../../utils/useAutoLogout";

const CoursesPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleLogout = () => userLogout(navigate, dispatch);
  useAutoLogout(handleLogout);

  return (
    <div className="overflow-hidden">
      <PageBanner
        title={COURSES_PAGE_BANNER?.title1}
        subtitle={COURSES_PAGE_BANNER?.subtitle}
        rightImgSrc={BANNER_IMG}
        backgroundGradient={
          "linear-gradient(to right, rgba(254, 246, 250, 0.9) 45%, rgba(102, 269, 244, 0.8))"
        }
        backgroundImage={BACKGROUND_IMAGE}
        fontColor={"#130C40"}
      />
      <div className="lg:mx-[10rem] md:mx-[3rem] mx-[1rem] lg:gap-8 gap-4 mt-10">
        {COURSES_PAGE_SHOW_COURSES_FILTER && (
          <div className="bg-green-300">filter</div>
        )}
          <CoursesList />
      </div>
    </div>
  );
};

export default CoursesPage;
